import BaseService from "./geral/BaseService";

const base = "AcompanhamentoProcesso";
const baseSolicitacao = "SolicitacaoDesovaPier";

export default class HomeService extends BaseService {

    constructor(props) {
        super(props)
    }

    GetApiVersion = () => {
        return super.httpGet(`/Version`)
    }

    
}


// WEBPACK FOOTER //
// ./src/services/HomeService.js